let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cFH97")).then(() => parcelRequire('4opAu'));